var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateValue),expression:"dateValue"}],ref:"date",class:['date-picker', _vm.size],attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":(_vm.dateValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dateValue=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eec0961","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/components/DatePicker.vue
// module id = 1009
// module chunks = 1